// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.7
//   protoc               v5.29.6
// source: phone_number.proto

export const protobufPackage = 'compasspb';

/** PhoneProvider identifies the telephony provider that owns a phone number. */
export enum PhoneProvider {
  PHONE_PROVIDER_UNSPECIFIED = 0,
  PHONE_PROVIDER_TWILIO = 1,
  PHONE_PROVIDER_TELNYX = 2,
}

/**
 * ProgramPhoneNumber is an outgoing phone number as a program holds it. id is the phone
 * number's id.
 */
export interface ProgramPhoneNumber {
  id?: string | undefined;
  organization_id?: string | undefined;
  phone?: string | undefined;
  provider?: PhoneProvider | undefined;
  label?: string | undefined;
  program_id?: string | undefined;
  created_at?: string | undefined;
  updated_at?: string | undefined;
}

/**
 * ListProgramPhoneNumbersRequest specifies the limit and filter options for listing the
 * phone numbers programs hold.
 */
export interface ListProgramPhoneNumbersRequest {
  organization_id?: string | undefined;
  program_id?: string | undefined;
  provider?: PhoneProvider | undefined;
  phone?: string | undefined;
  limit?: number | undefined;
}

/** ListProgramPhoneNumbersResponse contains the list of phone numbers. */
export interface ListProgramPhoneNumbersResponse {
  phone_numbers?: ProgramPhoneNumber[] | undefined;
  /**
   * Every carrier, in the order the dialpad offers them: the first is "Provider 1"
   * and the default pick. Global rather than per page or program, so a carrier keeps
   * its label everywhere. Ops set it in the "dialpad" dynconfig namespace.
   */
  provider_order?: PhoneProvider[] | undefined;
}

/**
 * PhoneNumber is the global record of which carrier owns a phone number.
 * A phone number carries no organization: there is exactly one record per number,
 * system-wide.
 */
export interface PhoneNumber {
  id?: string | undefined;
  phone?: string | undefined;
  provider?: PhoneProvider | undefined;
  created_at?: string | undefined;
  updated_at?: string | undefined;
  /** label is a free-text display name for the number. */
  label?: string | undefined;
  /** programs lists the programs the number is linked to. */
  programs?: PhoneNumberProgram[] | undefined;
  /** in_ai_pool is true when the number is in the AI call pool. */
  in_ai_pool?: boolean | undefined;
}

/** PhoneNumberProgram is a program a registered number is linked to. */
export interface PhoneNumberProgram {
  program_id?: string | undefined;
  program_name?: string | undefined;
  organization_id?: string | undefined;
}

/**
 * ListPhoneNumbersRequest filters the global phone number list.
 * There is no organization_id: phone numbers are global, and the RPC's permission annotation
 * rather than an organization membership check is the access boundary.
 */
export interface ListPhoneNumbersRequest {
  /**
   * phone is an EXACT match on the normalized E.164 value, not a prefix.
   * internal/db exposes no regex operator, and the service layer may not reach past
   * it. Callers wanting search filter the returned page themselves.
   */
  phone?: string | undefined;
  limit?: number | undefined;
  start_after_id?: string | undefined;
}

/** ListPhoneNumbersResponse contains the phone numbers and pagination info. */
export interface ListPhoneNumbersResponse {
  phone_numbers?: PhoneNumber[] | undefined;
  next_cursor?: string | undefined;
}

/** CreatePhoneNumberRequest provisions a number. */
export interface CreatePhoneNumberRequest {
  phone?: string | undefined;
  provider?: PhoneProvider | undefined;
  label?: string | undefined;
}

/** CreatePhoneNumberResponse wraps the new phone number. */
export interface CreatePhoneNumberResponse {
  phone_number?: PhoneNumber | undefined;
}

/**
 * UpdatePhoneNumberRequest updates a phone number. label is `optional`: absent means
 * leave unchanged, present-and-empty means clear.
 */
export interface UpdatePhoneNumberRequest {
  phone_number_id?: string | undefined;
  label?: string | undefined;
}

/** UpdatePhoneNumberResponse wraps the updated phone number. */
export interface UpdatePhoneNumberResponse {
  phone_number?: PhoneNumber | undefined;
}

/** DeletePhoneNumberRequest specifies the phone number to delete. */
export interface DeletePhoneNumberRequest {
  phone_number_id?: string | undefined;
}

/** DeletePhoneNumberResponse indicates whether the delete succeeded. */
export interface DeletePhoneNumberResponse {
  success?: boolean | undefined;
}

/** AddProgramPhoneNumberRequest links a registered number to a program. */
export interface AddProgramPhoneNumberRequest {
  organization_id?: string | undefined;
  program_id?: string | undefined;
  phone_number_id?: string | undefined;
}

/** AddProgramPhoneNumberResponse wraps the created program number. */
export interface AddProgramPhoneNumberResponse {
  phone_number?: ProgramPhoneNumber | undefined;
}

/** RemoveProgramPhoneNumberRequest unlinks a registered number from a program. */
export interface RemoveProgramPhoneNumberRequest {
  organization_id?: string | undefined;
  program_id?: string | undefined;
  phone_number_id?: string | undefined;
}

/** RemoveProgramPhoneNumberResponse indicates whether the unlink succeeded. */
export interface RemoveProgramPhoneNumberResponse {
  success?: boolean | undefined;
}

/**
 * PhoneNumberService manages phone numbers. The registry RPCs (create, update, delete,
 * list) are global and administrator-only. The program RPCs add or remove a phone number on
 * a program's list. ListProgramPhoneNumbers is a read for any user associated with the
 * organization.
 */
export interface PhoneNumberService {
  /** ListProgramPhoneNumbers retrieves the phone numbers listed on an organization's programs, truncated to the limit. */
  listProgramPhoneNumbers(
    request: ListProgramPhoneNumbersRequest,
  ): Promise<ListProgramPhoneNumbersResponse>;
  /** ListPhoneNumbers retrieves every provisioned number and its carrier. */
  listPhoneNumbers(request: ListPhoneNumbersRequest): Promise<ListPhoneNumbersResponse>;
  /** CreatePhoneNumber provisions a number and records the carrier that owns it. */
  createPhoneNumber(request: CreatePhoneNumberRequest): Promise<CreatePhoneNumberResponse>;
  /** UpdatePhoneNumber changes the mutable fields of a phone number. */
  updatePhoneNumber(request: UpdatePhoneNumberRequest): Promise<UpdatePhoneNumberResponse>;
  /** DeletePhoneNumber removes a phone number that no program uses. */
  deletePhoneNumber(request: DeletePhoneNumberRequest): Promise<DeletePhoneNumberResponse>;
  /** AddProgramPhoneNumber makes a registered number available to a program. */
  addProgramPhoneNumber(
    request: AddProgramPhoneNumberRequest,
  ): Promise<AddProgramPhoneNumberResponse>;
  /** RemoveProgramPhoneNumber unlinks a registered number from a program. */
  removeProgramPhoneNumber(
    request: RemoveProgramPhoneNumberRequest,
  ): Promise<RemoveProgramPhoneNumberResponse>;
}
